export const OTP_LIMIT_EXCEEDED = 'OTP_LIMIT_EXCEEDED';
export const OTP_VERIFICATION_ERROR = 'OTP_VERIFICATION_ERROR';

export const OTP_EXPIRY_TIME = 30; // 30 seconds
// 30 minutes is the block time for the user after 5 failed attempts
export const OTP_LIMIT_EXCEEDED_BLOCK_TIME_IN_SECONDS = 30 * 60;
